(function(){
	'strict';

	const $ = jQuery;

	function resetData() {
		this.metalsLogDate = null;
		this.workList = [];
	}

	Vue.component('tests-to-be-completed', {
		template: '#v-tests-to-be-completed',
		props: [],
		data: () => new resetData(),
		store,
        computed: {
			tests: x => store.state.testList,
			metalsTests: function() {
				return this.workList ? this.workList.filter( x => x.metal == 1 ) : [];
			},
			selectedTests: {
				get() {
					return this.workList ? this.workList.filter( x => x.selected == 1 ) : [];
				},
				set(value) {
					this.workList = this.tests ? this.tests.filter( x => x != null && x.worklistCount > 0 ).map( x => {
						x.selected = !!value.find( y => y.id == x.id );
						return x;
					}) : [];
				}
			},
			worklistCountMetals: function() {
				return this.metalsTests ? this.metalsTests.reduce(
					( total, test ) => total + ( test.worklistCount == null ? 0 : parseInt( test.worklistCount ) ),
				0 ) : 0;
			},
			worklistCountTotal: function() {
				return this.workList ? this.workList.reduce(
					( total, test ) => total + ( test.worklistCount == null ? 0 : parseInt( test.worklistCount ) ),
				0 ) : 0;
			},
		},
		methods: {
			resetData,
			onShowTab: function( openning ){
				LocalStorageManager.updateField( 'testList' );
				if ( openning ) {
					this.setMetalsLogDate();
					this.clearSelectedTests();
				}
			},
			setMetalsLogDate: function() {
				const date = new Date();

				if ( 1 == date.getDay() ) {
					date.setDate( date.getDate() - 3 ); // today is Monday
				} else {
					date.setDate( date.getDate() - 1 ); // today is NOT Monday
				}

				this.metalsLogDate = getLocalISODate(date);
			},
			setTests: function( testList ) {
				this.tests = testList;
			},
			clearSelectedTests: function() {
				this.workList = this.workList
					? this.workList.map( x => { x.selected = false; return x; } )
					: this.workList; // Force update
			},
			openTestWorklist: function() {
				AppTabs.getTab('worklist').controller.openTestWorklist( this.selectedTests );
			},
			openMetalsWorkList: function() {
				AppTabs.getTab('worklist').controller.openMetalsWorkList();
			},
			openMetalsLogList: function() {
				AppTabs.getTab('worklist').controller.openMetalsLogList( this.metalsLogDate );
			},
			toggle(id) {
				if ( ! this.workList )
					return;
				let old = this.workList.find( y => y.id == id );
				if (old)
					old.selected = !old.selected;
				this.workList = this.workList.filter(_ => true); // Force update
			},
		},
		watch: {
			tests(value) {
				if ( ! this.tests )
					return;

				this.workList = this.tests.filter( x => x != null && x.worklistCount > 0 ).map( x => {
					let old = this.workList ? this.workList.find( y => y.id == x.id ) || null : null;
					x.selected = old ? old.selected : false;
					return x;
				});
			}
		},
	});
})();
